import { User as UserFromAuth0 } from '@auth0/auth0-react';

export const POST_USER_UPSERT_PATH = '/v2/user/upsert';

export interface PostUserUpsertBodyReq {
  user?: UserFromAuth0;
}
